/** @typedef {import('./types').Icon} Icon */
/** @typedef {import('./types').Badge} Badge */


/**
 * @param {Icon} icon
 * @param {Badge} [badge]
 */
function getId(icon, badge) {
  let value = `tn-syos-seat-map-icon-${icon.name}`;

  if (badge) {
    value += `-b-${badge.name}`;
  }

  return value;
}


class SeatIconState {
  /**
   * @param {Icon} icon
   * @param {Badge} [badge]
   */
  constructor(icon, badge) {
    this.icon = icon;
    this.badge = badge;
    this.id = getId(icon, badge);
  }
}


export default SeatIconState;
